type Props = {
  currentQuestion: any;
};

const TextField = ({ currentQuestion }: Props) => {
  const { properties, responses } = currentQuestion;

  return (
    <div
      style={{
        fontSize: "14px",
        whiteSpace: properties?.allowMultiline ? "pre-wrap" : "normal",
      }}
    >
      {responses?.[0]?.textValue || ""}
    </div>
  );
};
export default TextField;
